import { render, staticRenderFns } from "./Crd.vue?vue&type=template&id=3647f85a"
import script from "./Crd.vue?vue&type=script&lang=js"
export * from "./Crd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports